/**
 * Styled-components theme for Reassure-UI component design system
 */

import pallette from './pallette';
import forms from './forms';
import page from './page';
import help from './help';
import button from './button';
import layout from './layout';
import panels from './panels';
import navigation from './navigation';
import modals from './modals';

const theme = {
    name: 'light',
    breakpoints: ['320px', '375px', '576px', '768px', '992px', '1400px'],
    colors: {
        primaryText: pallette.charcoal,
        secondaryText: pallette.white,
        ...page.colors,
        ...forms.colors,
        ...pallette,
        ...help.colors,
        ...button.colors,
        ...layout.colors,
        ...panels.colors,
        ...navigation.colors,
        ...modals.colors,
    },
    fonts: {
        serif: 'times, serif',
        sansSerif: '"Open Sans", "Helvetica Neue", "Helvetica", "Roboto", "Arial", sans-serif',
    },
    borderRadius: {
        small: '4px',
        medium: '6px',
        large: '8px',
    },
    sizes: ['0', '1px', '2px', '4px', '7px', '8px', '16px', '24px', '32px', '48px', '64px'],
    fontSizes: [
        '10px',
        '12px',
        '14px',
        '16px',
        '18px',
        '20px',
        '22px',
        '24px',
        '28px',
        '32px',
        '36px',
        '42px',
        '48px',
        '56px',
        '64px',
    ],
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900,
    },
    lineHeights: {
        solid: 1,
        title: 1.3,
        copy: 1.4,
        input: 1.5,
    },
    headings: { marginTop: 0.75, marginBottom: 0.35 },
    paragraphs: { marginTop: 0, marginBottom: 0.6 },
    space: ['0', '1px', '2px', '4px', '8px', '16px', '24px', '32px', '48px', '64px'],
} as const;

export default theme;
